"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var SendBoxContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var _default = SendBoxContext;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTZW5kQm94Q29udGV4dCIsImNyZWF0ZUNvbnRleHQiLCJ1bmRlZmluZWQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9wcm92aWRlcnMvaW50ZXJuYWwvU2VuZEJveC9wcml2YXRlL0NvbnRleHQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3JlYXRlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHR5cGUgeyBDb250ZXh0VHlwZSB9IGZyb20gJy4vdHlwZXMnO1xuXG5jb25zdCBTZW5kQm94Q29udGV4dCA9IGNyZWF0ZUNvbnRleHQ8Q29udGV4dFR5cGUgfCB1bmRlZmluZWQ+KHVuZGVmaW5lZCk7XG5cbmV4cG9ydCBkZWZhdWx0IFNlbmRCb3hDb250ZXh0O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBSUEsSUFBTUEsY0FBYyxnQkFBRyxJQUFBQyxvQkFBQSxFQUF1Q0MsU0FBdkMsQ0FBdkI7ZUFFZUYsYyJ9